// Business
export const SET_BUSINESS_LIST = 'SET_BUSINESS_LIST'
export const SET_USER_SELECTED_ACCOUNT = 'SET_USER_SELECTED_ACCOUNT'
export const SET_BUSINESS_BRANDING = 'SET_BUSINESS_BRANDING'
export const SET_BUSINESS_BRANDING_COLOR = 'SET_BUSINESS_BRANDING_COLOR'

// Locations
export const SET_ALL_LOCATIONS = 'SET_ALL_LOCATIONS'
export const SET_LOCATION = 'SET_LOCATION'
export const SET_LOCATION_ADDRESS = 'SET_LOCATION_ADDRESS'
export const SET_BUSINESS_USERS = 'SET_BUSINESS_USERS'
export const SET_SEARCHED_LOCATIONS = 'SET_SEARCHED_LOCATIONS'

// Location Groups
export const SET_LOCATION_GROUPS = 'SET_LOCATION_GROUPS'
export const SET_LOCATION_GROUP_WITH_LOCATION = 'SET_LOCATION_GROUP_WITH_LOCATION'

// Signage Devices
export const SET_ALL_SIGNAGE_DEVICES = 'SET_ALL_SIGNAGE_DEVICES'
export const SET_ALL_SIGNAGE_DEVICES_PAGED_WITH_L0CATIONS = 'SET_ALL_SIGNAGE_DEVICES_PAGED_WITH_L0CATIONS'
export const SET_BEACON_LOGS = 'SET_BEACON_LOGS'
export const SET_DEVICES_SUMMARY = 'SET_DEVICES_SUMMARY'
export const SET_DEVICES_CAMPAIGN = 'SET_DEVICES_CAMPAIGN'
export const SET_DEVICES_REQUESTS = 'SET_DEVICES_REQUESTS'
export const SET_DEVICES_STATUS_LOGS = 'SET_DEVICES_STATUS_LOGS'
export const SET_RECENTLY_GENERATED_REPORTS = 'SET_RECENTLY_GENERATED_REPORTS'
